import { Link } from "react-router-dom";

export function AppFooter() {
  return (
    <footer className="app-footer" data-testid="app-footer">
      <Link to="/privacy-terms" data-testid="footer-privacy-terms-link">Privacy &amp; Terms</Link>
    </footer>
  );
}